import { memo, useMemo } from 'react';
import { Typography, Tooltip, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PublicIcon from '@mui/icons-material/Public';

import { savedSearchIconButtonStyle } from 'components/SavedSearch/SavedSearchStyles';
import { SavedSearchItem } from 'providers/contexts/extensions/SavedSearches';

export const searchNameFieldStyle = (theme: any) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  '&.MuiTypography-root': {
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.primary,
  },
});

export const SearchSavedNameField = memo(({ record }: SavedSearchItem) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const uiShared = t('blox.search.saved.shared');

  const sxIconStyle = useMemo(() => {
    return savedSearchIconButtonStyle(theme);
  }, [theme]);

  return (
    <Typography sx={searchNameFieldStyle}>
      {record?.shared && (
        <Tooltip title={uiShared}>
          <PublicIcon sx={sxIconStyle} />
        </Tooltip>
      )}
      {record?.name || ''}
      <OpenInNewIcon sx={sxIconStyle} />
    </Typography>
  );
});

SearchSavedNameField.displayName = 'SearchSavedNameField';

export default SearchSavedNameField;
